import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import '@maersk-global/mds-components-core/mc-input-date';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-option';

export interface DateFilterTypeOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-date-filter-row',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './date-filter-row.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DateFilterRowComponent {
  @Input({ required: true }) formGroup!: FormGroup;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) typeControlName!: string;
  @Input({ required: true }) dateControlName!: string;
  @Input({ required: true }) fromControlName!: string;
  @Input({ required: true }) toControlName!: string;
  @Input() options: DateFilterTypeOption[] = [
    { value: 'EQUALS', label: 'Equals' },
    { value: 'ON_OR_BEFORE', label: 'On or Before' },
    { value: 'ON_OR_AFTER', label: 'On or After' },
    { value: 'BETWEEN', label: 'Between' },
    { value: 'BEFORE', label: 'Before' },
    { value: 'AFTER', label: 'After' },
  ];

  get isBetween(): boolean {
    return this.formGroup.get(this.typeControlName)?.value === 'BETWEEN';
  }
}
